"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useIntl = exports.IntlConsumer = exports.IntlProvider = void 0;
var React = _interopRequireWildcard(require("react"));
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _Intl = require("../../records/Intl");
var _translate = _interopRequireDefault(require("./translate"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const context = /*#__PURE__*/React.createContext({
  ..._Intl.intlDefault,
  onDebug: () => {}
});
context.displayName = "IntlNitroContext";
const {
  Provider,
  Consumer: IntlConsumer
} = context;
exports.IntlConsumer = IntlConsumer;
const IntlProvider = ({
  children,
  intl,
  locale
}) => {
  const [debug, setDebug] = React.useState(false);
  const handleDebug = React.useCallback(() => {
    setDebug(state => !state);
  }, []);
  const handleTranslate = React.useCallback((key, values, opts) => debug ? key : (0, _translate.default)(intl.translations, key, values, opts), [debug, intl.translations]);
  const localePromise = React.useMemo(() => locale !== null && locale !== void 0 ? locale : Promise.resolve(_enUS.default), [locale]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: {
      language: intl.language,
      translations: intl.translations,
      translate: handleTranslate,
      getLocale: localePromise,
      onDebug: handleDebug
    },
    children: children
  });
};
exports.IntlProvider = IntlProvider;
const useIntl = () => React.useContext(context);
exports.useIntl = useIntl;
var _default = context;
exports.default = _default;